module.exports = __webpack_public_path__ + "fonts/Barlow-Bold.07166ed.woff2";